import {Preservative} from 'types/model/enumeration/Preservative';
import {SelectOptions} from 'forms/components/BasicSelect';

export const preservativeOptions: SelectOptions<Preservative> = [
    {value: 'AZIDIOL', label: 'Azidiol'},
    {value: 'HESCHEN', label: 'Heschenovo činidlo'},
    {value: 'BRONOPOL', label: 'Bronopol'},
    {value: 'NONE', label: 'Nekonzervované'},
];
